<ng-container *ngIf="!showLoaderPhases; else loaderTemplate">
  <app-loader-circles *ngIf="showLoader"></app-loader-circles>

  <div class="content">
    <form [formGroup]="form" class="forms">
      <div class="header">
        <h2>Resultado Parcial</h2>

        <button class="icon-full pt-6" (click)="abrirModalProdutos()">
          <span class="fa fa-gear"></span>
        </button>
      </div>

      <div class="panel-content">
        <div class="content-header position-relative">
          <div class="header-title">Valor Solicitado</div>
          <div class="header-content">
            <div class="icone icon-patrimonio"></div>
            <div>
              {{
                form.get('valorFinanciamento').value || '0.0'
                  | currency: 'BRL':'symbol':'1.2-2'
              }}
            </div>
          </div>

          <div class="header-options">
            <button
              class="btn btn-border-orange"
              (click)="abrirModalAlterarValor()"
            >
              Alterar Valores
            </button>

            <button class="btn btn-border" (click)="abrirModalTabelas()">
              Tabela
            </button>
          </div>
        </div>

        <div class="content-body">
          <div class="calculo-title">Opções de parcelamento</div>
          <div class="body-content">
            <parcela
              [formParent]="form"
              [parcelaMax]="parcelaMax"
              [parcelas]="parcelas"
            ></parcela>

            <div class="panel-actions">
              <app-btn-small color="primary">
                <calendar
                  titleCalendar="Data para pagamento"
                  [startDate]="
                    propostaSimulacao.simulacao.gracePeriodRange.from
                  "
                  [endDate]="propostaSimulacao.simulacao.gracePeriodRange.to"
                  [dateSelected]="propostaSimulacao.simulacao.primeiraParcela"
                  (dateSelectedChange)="onChangePrimeiraParcela($event)"
                >
                  <span class="fa fa-calendar"></span>
                  Vencimento: {{((propostaSimulacao.simulacao.primeiraParcela * 1000 | date: 'dd/MM/yyyy') || 'Selecione uma data')}}
                </calendar>
              </app-btn-small>

              <app-btn-small
                *ngIf="
                  propostaSimulacao.proposta.transients.parcela &&
                  propostaSimulacao.proposta.transients.parcela.valorRetido &&
                  !isCessao
                "
                (click)="abrirModalRetencao()"
                color="secondary"
                title="Retenção"
              >
                <span class="fa fa-money mr-5"></span>
              </app-btn-small>
            </div>
          </div>
        </div>

        <div class="content-footer" (click)="abrirModalParcelaPersonalizada()">
          <a class="content-footer__action">
            <span class="fa fa-plus content-footer__icon"></span>
            Opções de parcelamento
          </a>
        </div>
      </div>
    </form>

    <div *ngIf="!showTryAgainButton" class="btn-navegacao">
      <app-botao-navegacao-clean
        (next)="onClickNext()"
        [previousShow]="false"
        [nextShow]="true"
        [nextEnabled]="form.valid"
        nextLabel="Analisar"
      >
      </app-botao-navegacao-clean>
    </div>

    <div
      *ngIf="showTryAgainButton"
      class="btn-navegacao btn-analisar-novamente"
    >
      <button
        class="bt-go btn btn-full-orange"
        (click)="onClickTryAgain()"
        [disabled]="!form.valid"
      >
        Analisar novamente
      </button>
    </div>
  </div>
</ng-container>

<ng-template #loaderTemplate>
  <div class="loader-phases">
    <app-loader-phases
      [phases]="['Aguarde, validando informações.']"
    ></app-loader-phases>
  </div>
</ng-template>
